/**
 * Route names defined for routes that are
 * shared between all user types and have
 * the same design layout as the rest of the app
 */
export const sharedRouteNames = {
  login: 'login',
  signUp: 'sign-up',
  successfulSignUp: 'successful-sign-up',
  signUpVerification: 'sign-up-verification',
  register: 'register',
  cyberGuardA1: 'cyberGuardA1',
  organizationStore: 'organization-store',
  customRegister: 'custom-register',
  editAttendeeData: 'edit-attendee-data',
  error404: 'error-404',
  userProfile: 'user-profile',
  forgotPassword: 'forgot-password',
  recoverPassword: 'recover-password',
  failedPayment: 'failed-payment',
  canceledPayment: 'canceled-payment',
  acceptInvite: 'accept-invite',
  curatedInviteResponse: 'curated-invite-response',
  annualTicketInvite: 'annual-ticket-invite',
  sportSubscriptionsStore: 'sport-subscriptions-store',
  sportMembershipsStore: 'sport-memberships-store',
}
